// extracted by mini-css-extract-plugin
export default {"grid":"SignIn_grid__1WIqc","title":"SignIn_title__fyKj2","flex":"SignIn_flex__JfYmD","button":"SignIn_button__STZve"};